import { TransferItem } from "antd/lib/transfer";
export interface IProjectForm {
  newName: string;
  status: number;
  paramsLocked: [];
}
export interface IUser {
  isSelect: string;
  userId: string;
  userName: string;
  isDingTalk: number;
}

export interface ITransferProps {
  id: string;
  text: string;
  deptIdList: number[] | null;
  isDingTalkOriganize?: boolean;
  deptId?: string | number;
}

export interface IProject {
  projectId: number;
  projectName: string;
  status: number;
  type: number;
  users: IUser[];
}
export namespace Project {
  export enum OperationType {
    EDIT = "edit",
    ADD = "add",
  }
  export enum Status {
    OPEN = 0,
    CLOSE,
  }
  export type Info = {
    projectId: number;
    projectName: string;
    status: number;
    type: number;
    users: IUser[];
    munuTaskOverTime: number;
    munuTaskOverTimeStatus: Status;
    renderNum: number;
    renderNumStatus: Status;
    taskOverTime: number;
    taskOverTimeStatus: Status;
    createTime: string;
    createUserName: string;
    userId: number;
  };
  export namespace Params {
    export enum Type {
      GET = 0, //获取标签
      ADD, //添加
      DELETE, //删除
    }

    export type Form = {
      projectId: string;
      taskId: string;
      newName: string;
      status: Status;
      label: string;
      ids: any;
      renderNum: number;
      renderNumStatus: Status;
      taskOverTime: number;
      taskOverTimeStatus: Status;
      munuTaskOverTime: number;
      munuTaskOverTimeStatus: Status;
      type?: Type;
    };
  }
}
export interface IdeptInfo {
  [key: string]: any;
  parentId: number | null;
  deptId: number | null;
  name: string;
  isSync?: number;
  id?: number | null;
  totalPersonnel?: number;
  position?: string | null;
  isLeader?: number | null;
  isExist?: number | null;
  deptList: IdeptInfo[];
  keyIndex: number;
}

export type TransferPropsType = {
  showSelectAll: boolean;
  dataSource: TransferItem[];
  targetKeys: ITransferProps[];
  selectedKeys: string[];
  onSelectChange: (sourceSelectedKeys: ITransferProps[]) => void;
  handleRemoveChange: (sourceSelectedKeys: ITransferProps) => void;
};
